import { totalRecordByDateConstants, totalRecordByDateConstants2, departmentAndEmployeeConstants, departmentAndEmployeeConstantsExport } from '../constant/totalRecord.constants';
import { totalRecordByDate, totalRecordByDate2, departmentAndEmployee, departmentAndEmployeeExport } from '../services/totalRecord.service';
import CONSTANT from '../constant/constant';
import functionCommon from "../common/function";

const _errorCode = CONSTANT.errorCode;

export const getTotalRecordByDate = (data) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }    
    return dispatch => {
        totalRecordByDate.list(data)
            .then(
                res => {
                    if(!res) return;
                    switch (res['http_code']) {
                        case _errorCode.APISuccess:
                            dispatch(success(res.result));
                            if (res['error_code']) {
                                dispatch(failure(res['error_code']));
                            }
                            break;

                        case _errorCode.TOKENExpired:
                            functionCommon.logout()
                            break;

                        default:
                            window.location = '/error/404';
                            break;
                    }
                   
                }
            );
    };

    function success(totalRecordByDateList) { 
        return { type:  totalRecordByDateConstants.GET_SUCCESS, totalRecordByDateList }; 
    }

    function failure(error) { 
        return { type:  totalRecordByDateConstants.GET_FAILURE, error }; 
    }
}

export const getTotalRecordByDate2 = (data) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }    
    return dispatch => {
        totalRecordByDate2.list(data)
            .then(
                res => {
                    if(!res) return;
                    switch (res['http_code']) {
                        case _errorCode.APISuccess:
                            dispatch(success(res.result));
                            if (res['error_code']) {
                                dispatch(failure(res['error_code']));
                            }
                            break;

                        case _errorCode.TOKENExpired:
                            functionCommon.logout()
                            break;

                        default:
                            window.location = '/error/404';
                            break;
                    }
                   
                }
            );
    };

    function success(totalRecordByDateList2) { 
        return { type:  totalRecordByDateConstants2.GET_SUCCESS, totalRecordByDateList2 }; 
    }

    function failure(error) { 
        return { type:  totalRecordByDateConstants2.GET_FAILURE, error }; 
    }
}

export const getDataDepartmentAndEmployee = (data) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }
    return dispatch => {
        dispatch(getting());
        departmentAndEmployee.list(data).then((res) => {
            if (!res) return;
            switch (res['http_code']) {
                case _errorCode.APISuccess:
                    dispatch(success(res.result));
                    break;
                case _errorCode.TOKENExpired:
                    functionCommon.logout();
                    break;
                case _errorCode.APIInvalids:
                    functionCommon.logout();
                    break;
                case _errorCode.ClientNotPermission:
                    functionCommon.logout();
                    break;
                default:
                    window.location = '/error/404';
                    break;
            }
        })
    }
    
    function success(departmentListAndEmployee) {
        return { type: departmentAndEmployeeConstants.GET_SUCCESS, departmentListAndEmployee };
    }

    function getting() {
        return { type: departmentAndEmployeeConstants.GETTING };
    }
}

export const getDataDepartmentAndEmployeeExport = (data) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }
    return dispatch => {
        departmentAndEmployeeExport.list(data).then((res) => {
            if (!res) return;
            switch (res['http_code']) {
                case _errorCode.APISuccess:
                    dispatch(success(res.result));
                    break;
                case _errorCode.TOKENExpired:
                    functionCommon.logout();
                    break;
                case _errorCode.APIInvalids:
                    functionCommon.logout();
                    break;
                case _errorCode.ClientNotPermission:
                    functionCommon.logout();
                    break;
                default:
                    window.location = '/error/404';
                    break;
            }
        })
    }
    
    function success(departmentListAndEmployee) {
        return { type: departmentAndEmployeeConstantsExport.GET_SUCCESS, departmentListAndEmployee };
    }
}

export const deleteDataEmployeeExport = () => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }
    return (dispatch) => {
        dispatch(deleteEmployeeExport());
    };
    function deleteEmployeeExport() {
        const employee = [];
        return { type: departmentAndEmployeeConstantsExport.DELETE, employee };
    }
}
